import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Close } from '../assets/closeBtn.svg';
import { ReactComponent as DeleteIcon } from '../assets/deleteIcon.svg';
import { ReactComponent as AddIcon } from '../assets/addIcon.svg';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from "../config";
import Header from './Header';
import ButtonIcon from '../assets/button-icon.png';

const GENDER_TYPES = {
    MALE: 'Мужской',
    FEMALE: 'Женский'
};

const UpgradeDetail = () => {
    const { title } = useParams();
    const navigate = useNavigate();

    const [buttons, setButtons] = useState({});
    const [newButtonName, setNewButtonName] = useState('');
    const [newButtonIcon, setNewButtonIcon] = useState('');
    const [newButtonDescription, setNewButtonDescription] = useState('');
    const adminMode = useSelector((state) => state.adminMode.adminMode);
    const userGender = useSelector((state) => state.user.gender);
    const [selectedGender, setSelectedGender] = useState(userGender || GENDER_TYPES.MALE);
    const initData = window.Telegram.WebApp.initData;

    // Определяем, какой пол использовать для запросов
    const genderToUse = adminMode ? selectedGender : userGender;

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/buttons/get?title=${title}&gender=${genderToUse}`)
            .then(({ data }) => {
                if (data.success) {
                    setButtons(data.buttons || {});
                }
            })
            .catch(() => console.error('Ошибка при загрузке кнопок'));
    }, [title, genderToUse]);

    const handleClose = () => navigate('/upgrade');

    const handleOpenDetail = (buttonName) => {
        navigate(`/upgrade/${encodeURIComponent(title)}/detail/${encodeURIComponent(buttonName)}`);
    };

    const handleDelete = (buttonName) => {
        const newButtons = { ...buttons };
        delete newButtons[buttonName];
        setButtons(newButtons);
    };

    const handleAdd = () => {
        if (newButtonName.trim()) {
            setButtons({
                ...buttons,
                [newButtonName]: {
                    description: newButtonDescription,
                    icon: newButtonIcon
                }
            });

            setNewButtonName('');
            setNewButtonDescription('');
            setNewButtonIcon('');
        }
    };

    const handleSave = async () => {
        try {
            // Получаем текущие кнопки с сервера, чтобы определить новые
            const { data: currentData } = await axios.get(`${config.API_BASE_URL}/buttons/get?title=${title}&gender=${genderToUse}`);
            const currentButtons = currentData.success ? currentData.buttons || {} : {};

            // Находим новые кнопки (те, которых нет в текущих)
            const newButtons = Object.keys(buttons).filter(buttonName => !currentButtons[buttonName]);

            // Сохраняем все кнопки
            const saveResponse = await axios.post(`${config.API_BASE_URL}/buttons/save`, {
                title,
                buttons,
                initData,
                gender: genderToUse
            });

            if (saveResponse.data.success) {
                // Отправляем уведомления для каждой новой кнопки
                const notificationPromises = newButtons.map(buttonName => {
                    const buttonData = buttons[buttonName];

                    // Создаем метаданные для навигации
                    const metadata = {
                        section: title,
                        button: buttonName
                    };

                    console.log(`Создание уведомления для "${buttonName}" с метаданными:`, metadata);

                    return axios.post(`${config.API_BASE_URL}/notifications/create`, {
                        title: 'Новый материал',
                        message: `Добавлен новый материал "${buttonName}" в раздел "${title}"`,
                        category: 'new_content',
                        initData,
                        gender: genderToUse,
                        metadata: metadata
                    });
                });

                // Ждем завершения всех запросов на создание уведомлений
                const results = await Promise.all(notificationPromises);
                console.log(`Отправлены уведомления для ${newButtons.length} новых материалов:`,
                    results.map(r => r.data.success ? 'успешно' : 'ошибка'));
            }
        } catch (error) {
            console.error('Ошибка сохранения:', error);
        }
    };

    return (
        <>
            <Header />
            <div className="upgrade-detail">
                <div className='upgrade-header'>
                    <button className="close-button" onClick={handleClose}>
                        <Close />
                    </button>
                    <h2>{title}</h2>
                </div>

                {adminMode && (
                    <div className="admin-controls">
                        <div className="gender-selector">
                            <p>Выберите пол для редактирования:</p>
                            <div className="gender-buttons">
                                <button
                                    className={`gender-button ${selectedGender === GENDER_TYPES.MALE ? 'active' : ''}`}
                                    onClick={() => setSelectedGender(GENDER_TYPES.MALE)}
                                >
                                    Мужской
                                </button>
                                <button
                                    className={`gender-button ${selectedGender === GENDER_TYPES.FEMALE ? 'active' : ''}`}
                                    onClick={() => setSelectedGender(GENDER_TYPES.FEMALE)}
                                >
                                    Женский
                                </button>
                            </div>
                            <p className="current-gender">Текущий выбранный пол: <strong>{selectedGender}</strong></p>
                        </div>
                        <div className="add-button-form">
                            <input
                                type="text"
                                value={newButtonName}
                                onChange={(e) => setNewButtonName(e.target.value)}
                                placeholder="Название кнопки"
                            />
                            <textarea
                                value={newButtonDescription}
                                onChange={(e) => setNewButtonDescription(e.target.value)}
                                placeholder="Описание кнопки"
                                rows={3}
                            />
                            <input
                                type="text"
                                value={newButtonIcon}
                                onChange={(e) => setNewButtonIcon(e.target.value)}
                                placeholder="URL иконки кнопки (необязательно)"
                            />
                            <div className="button-row">
                                <button className="add-button" onClick={handleAdd}>
                                    <AddIcon /> Добавить
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="buttons-section">
                    <div className="button-list">
                        {Object.entries(buttons).map(([name, { description, icon }]) => (
                            <div key={name} className="button-item">
                                <button
                                    className="content-button"
                                    onClick={() => handleOpenDetail(name)}
                                >
                                    <div className="button-content">
                                        {icon ? (
                                            <img
                                                src={icon}
                                                alt=""
                                                className="button-icon"
                                                onError={(e) => {
                                                    // Заменяем на div с синим фоном при ошибке загрузки
                                                    const parent = e.target.parentNode;
                                                    const div = document.createElement('div');
                                                    div.className = 'button-icon blue-background';
                                                    parent.replaceChild(div, e.target);
                                                }}
                                            />
                                        ) : (
                                            <div className="button-icon blue-background"></div>
                                        )}
                                        <div className="button-text">
                                            <span className="button-name">{name}</span>
                                            {description && (
                                                <span className="button-description">{description}</span>
                                            )}
                                        </div>
                                    </div>
                                </button>
                                {adminMode && (
                                    <button
                                        className="delete-button"
                                        onClick={() => handleDelete(name)}
                                    >
                                        <DeleteIcon />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {adminMode && (
                    <button className="save-button" onClick={handleSave}>
                        Сохранить изменения
                    </button>
                )}
            </div>
        </>
    );
};

export default UpgradeDetail;
